<template>
  <div class="login_wrap">
    <div>
      <img :src="logo" alt="logo" class="logo" />
      <div class="title_wrap">
        <div class="subTitle">{{ language("login.subTitle") }}</div>
      </div>
      <div>
        <el-card>
          <h1>密码重置</h1>
          <el-form
            :model="form"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="旧密码" prop="oldPwd">
              <el-input
                v-model="form.oldPwd"
                placeholder="请输入旧密码"
                type="password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPwd">
              <el-input
                v-model="form.newPwd"
                placeholder="请输入新密码"
                type="password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="rePwd">
              <el-input
                v-model="form.rePwd"
                placeholder="请再次输入新密码"
                type="password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button  @click="goToLogin" 
                >返回</el-button
              >
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                class="login_button"
                >重置密码</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      logo: require("../../assets/logo.png"),
      form: {},
      rules: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [
          {
            validator: this.validatePass,
            trigger: "change",
            required: true,
          },
        ],
        rePwd: [
          {
            validator: this.validatePass2,
            trigger: "change",
            required: true,
          },
        ],
      },
    };
  },
  watch: {},
  methods: {
    validatePass2(rule, value, callback) {
      if (!this.form.rePwd || this.form.rePwd == "") {
        callback(new Error("请再次输入新密码"));
      } else if (this.form.rePwd !== this.form.newPwd) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    },
    validatePass(rule, value, callback) {
      if (!this.form.newPwd || this.form.newPwd == "") {
        callback(new Error("请输入新密码"));
      } else if (this.form.newPwd) {
        var r = /^[A-Za-z0-9_]*$/;
        if (!r.test(this.form.newPwd)) {
          callback(new Error("只能包含数字和字母"));
        } else if (this.form.newPwd.length != 8) {
          callback(new Error("密码长度为8位数"));
        }
        callback();
      }
    },
    submitForm(formName) {
      console.log(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ccRequest
            .do("mgr/changePwd", this.form, "POST")
            .then((res) => {
              localStorage.removeItem(process.env.VUE_APP_logoKey);

              this.$alert("重置成功", "提示", {
                confirmButtonText: "去登录",
                type: "success",
                callback: (action) => {
                  console.log(action);
                  if (action == "confirm") {
                    this.$router.push({
                      path: "/admin/sys/login",
                    });
                  }
                },
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          return false;
        }
      });
    },
    goToLogin() {
      this.$router.push({
        path: "/admin/sys/login",
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.login_wrap {
  display: flex;
  justify-content: center;

  padding-top: 100px;
  box-sizing: border-box;
}
.title_wrap {
  padding: 0 0 20px 0;
  margin: 10px auto 0 auto;
  font-weight: 600;
  width: 620px;
  div {
    text-align: center;
  }
  .title {
    font-size: 36px;
    margin-bottom: 10px;
    color: #878787;
  }
  .subTitle {
    font-size: 20px;
  }
}
.logo {
  width: 300px;
  margin: 0 auto;
  display: block;
}
.login_button {
  background: #000;
  border-color: #000 !important;
}
h1 {
  text-align: center;
  padding: 20px 0;
}
</style>